import { render, staticRenderFns } from "./CategoryDiscountProgress.vue?vue&type=template&id=5ac0f906&"
import script from "./CategoryDiscountProgress.vue?vue&type=script&lang=js&"
export * from "./CategoryDiscountProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/orca/workspaces/DIA-3dprima_v2/task-50584/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac0f906')) {
      api.createRecord('5ac0f906', component.options)
    } else {
      api.reload('5ac0f906', component.options)
    }
    module.hot.accept("./CategoryDiscountProgress.vue?vue&type=template&id=5ac0f906&", function () {
      api.rerender('5ac0f906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/CategoryDiscountProgress.vue"
export default component.exports